import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from '../../../language'
import Button from '../../../utils/components/Button/Button'
import Input from '../../../utils/components/Input/Input'
import circle from '../../../assets/img/circulogris.png';
import './RequestRepresentative.css'
import { usePlaces } from '../../../utils/hooks/usePlaces';
import File from '../../../utils/components/File/File'
import localStorage from '../../../utils/hooks/useLocalStorage'

const EditEcoTienda = ({ formik, tittle = "", isEcoTienda = false }) => {
    usePlaces(formik.values.businessCountry, formik.values.businessDepartment)
    const { countries, states, cities } = useSelector(state => state.locations)

    return (
        <div className="">
            <div className="title-register">Editar información de EcoTienda</div>
            <div className="content-request-franchisee">
                <div className="content-picture-request-franchisee">
                    {localStorage().getItem("picturProfile") ? <img alt="img" className="img-request-franchisee" onError={(e) => e.target.src = circle} src={localStorage().getItem("picturProfile")}></img> :
                        <img alt="img" className="img-request-franchisee" src={circle}></img>}
                </div>
                <div className="content-data-request-franchisee">
                    <div className="content-inputs-request-franchisee">


                        <Input
                            name="socialReason"
                            type="text"
                            placeholder={'*Razón social'}
                            value={formik.values.socialReason}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.socialReason}
                        />
                        <div className='input-select-style-container'>
                            <select className='input-select-style' name="businessCountry" value={formik.values.businessCountry} onChange={formik.handleChange}>
                                <option value="">Seleccione</option>
                                {countries.map((country) => (
                                    <option key={country.countryID} value={country.countryName}>
                                        {country.countryName}
                                    </option>
                                )
                                )}
                            </select>
                        </div>
                        <div className='input-select-style-container'>
                            <select className='input-select-style' name="businessDepartment" value={formik.values.businessDepartment} onChange={formik.handleChange}>
                                <option value="">Seleccione</option>
                                {states.map((state) => (
                                    <option key={state.stateID} value={state.stateName}>
                                        {state.stateName}
                                    </option>
                                )
                                )}
                            </select>
                        </div>

                        <div className='input-select-style-container'>
                            <select className='input-select-style' name="businessCity" value={formik.values.businessCity} onChange={formik.handleChange}>
                                <option value="">Seleccione</option>
                                {cities.map((city) => (
                                    <option key={city.cityID} value={city.cityName}>
                                        {city.cityName}
                                    </option>
                                )
                                )}
                            </select>
                        </div>
                        <Input
                            name="businessLocation"
                            type="text"
                            placeholder={'*Ubicación del negocio'}
                            value={formik.values.businessLocation}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.businessLocation}
                        />
                        <Input
                            name="businessAddress"
                            type="text"
                            placeholder={'*Dirección del negocio'}
                            value={formik.values.businessAddress}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.businessAddress}
                        />
                        <Input
                            name="businessEmail"
                            type="text"
                            placeholder={'*Correo del negocio'}
                            value={formik.values.businessEmail}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.businessEmail}
                        />
                        <Input
                            name="businessPhone"
                            type="text"
                            placeholder={'*Numero de telefono'}
                            value={formik.values.businessPhone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.businessPhone}
                        />
                    </div>
                    <Button onClick={formik.handleSubmit} classNameContent={"button-save-request-franchisee"} text={Translate('send', 'es')} theme="white" />
                </div>
            </div>
        </div>
    )
}

export default EditEcoTienda
